import { useCallback, useEffect, useRef } from "react";

export const useOnLeave = ({ shouldConfirm = false }) => {
  const listenerRef = useRef(null);

  const confirmLeave = useCallback(
    (event) => {
      event?.preventDefault();
      // Chrome requires returnValue to be set.
      if (shouldConfirm) {
        if ("returnValue" in event) {
          event.returnValue = "";
        }
        return "";
      }
      return null;
    },
    [shouldConfirm]
  );

  useEffect(() => {
    if (listenerRef.current) {
      window.removeEventListener("beforeunload", listenerRef.current);
    }

    if (shouldConfirm) {
      listenerRef.current = confirmLeave;
      window.addEventListener("beforeunload", confirmLeave);
    } else {
      listenerRef.current = null;
    }

    return () => {
      if (listenerRef.current) {
        window.removeEventListener("beforeunload", listenerRef.current);
      }
    };
  }, [shouldConfirm, confirmLeave]);
};
